/* NCL Accessibility fixes — axe-core 4.9.1 audit remediation
   Addresses: Issues 3,10,17,18,19,20,21,22
   - fixStampedBadges(): corrected selector (was too broad, wrongly applied role=img to launcher button)
   - fixLandmarks(): wraps NavDrawer, announcement bar, footer, rewards launcher in ARIA landmarks
   - fixEmptyLinks(): adds aria-label to empty Powered-by-Shopify anchor
   Last updated: 2026-05-20
*/

(function () {
  'use strict';

  /* --- 1. STAMPED BADGES ---------------------------------------------------
     Only .stamped-badge and .stamped-starrating elements that carry an aria-label
     should get role="img". Explicitly strip role="img" from any Stamped <button>
     or <a> elements (the launcher button had it incorrectly applied).
  -------------------------------------------------------------------------- */
  function fixStampedBadges() {
    var badges = document.querySelectorAll(
      '.stamped-badge[aria-label], .stamped-starrating[aria-label]'
    );
    badges.forEach(function (el) {
      var tag = el.tagName.toLowerCase();
      if (tag === 'button' || tag === 'a') return;
      el.setAttribute('role', 'img');
    });

    var stampedInteractive = document.querySelectorAll(
      'button[class*="stamped"][role="img"], a[class*="stamped"][role="img"]'
    );
    stampedInteractive.forEach(function (el) {
      el.removeAttribute('role');
    });
  }

  /* --- 2. ARIA LANDMARKS --------------------------------------------------
     a) #NavDrawer — mobile nav drawer (CSS-transform hidden, not display:none)
     b) [id^="shopify-section-"] containing .announcement_wrapper
     c) .footer-wrapper <div> — page footer rendered as div, not <footer>
     d) .stamped-rewards-launcher — Stamped rewards widget
  -------------------------------------------------------------------------- */
  function fixLandmarks() {
    var navDrawer = document.getElementById('NavDrawer');
    if (navDrawer && !navDrawer.getAttribute('role')) {
      navDrawer.setAttribute('role', 'navigation');
      navDrawer.setAttribute('aria-label', 'Mobile menu');
    }

    var announcementEl = document.querySelector('.announcement_wrapper');
    if (announcementEl) {
      var sectionEl = announcementEl.closest('[id^="shopify-section-"]');
      if (sectionEl && !sectionEl.getAttribute('role')) {
        sectionEl.setAttribute('role', 'region');
        sectionEl.setAttribute('aria-label', 'Announcements');
      }
    }

    var footerWrapper = document.querySelector('.footer-wrapper');
    if (footerWrapper) {
      var fwTag = footerWrapper.tagName.toLowerCase();
      if (fwTag !== 'footer' && !footerWrapper.getAttribute('role')) {
        footerWrapper.setAttribute('role', 'contentinfo');
      }
    }

    var rewardsLauncher = document.querySelector('.stamped-rewards-launcher');
    if (rewardsLauncher && !rewardsLauncher.getAttribute('role')) {
      rewardsLauncher.setAttribute('role', 'complementary');
      rewardsLauncher.setAttribute('aria-label', 'Rewards program');
    }
  }

  /* --- 3. EMPTY LINKS -----------------------------------------------------
     The "Powered by Shopify" anchor renders with only whitespace as its text
     content, creating an empty link with no accessible name.
  -------------------------------------------------------------------------- */
  function fixEmptyLinks() {
    var shopifyLinks = document.querySelectorAll('a[href*="shopify.com"]');
    shopifyLinks.forEach(function (link) {
      var text = link.textContent.trim();
      var hasImage = link.querySelector('img[alt], svg[aria-label], svg[title]');
      if (!text && !hasImage && !link.getAttribute('aria-label')) {
        link.setAttribute('aria-label', 'Powered by Shopify (opens in new tab)');
      }
    });
  }

  /* --- INIT --------------------------------------------------------------- */
  function applyAllFixes() {
    fixStampedBadges();
    fixLandmarks();
    fixEmptyLinks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAllFixes);
  } else {
    applyAllFixes();
  }

  window.addEventListener('load', function () {
    applyAllFixes();
  });

  document.addEventListener('shopify:section:load', function () {
    applyAllFixes();
  });

})();
